import { render, staticRenderFns } from "./InputCompany.vue?vue&type=template&id=da045968&"
import script from "./InputCompany.vue?vue&type=script&lang=js&"
export * from "./InputCompany.vue?vue&type=script&lang=js&"
import style0 from "./InputCompany.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports